<template>
    <div class="info-page">
      <div class="back vd-back" @click="back" style="margin-top: 0;">
        <img width="25" src="../../static/images/back.png" />
      </div>
      <div class="">
        <video ref="videoPlayer" v-if="info.video_path"  class="video-player" controls autoplay playsinline webkit-playsinline preload="auto" id="myVideo"
               @play="onPlay"
               @pause="onPause"
               @ended="onEnded"
               @seeking="onSeeking"
               @ratechange="onRateChange" :key="info.video_path">
          <source :src="info.video_path" type="video/mp4">
        </video>
        <div class="block2-font">
          <div class="fw7">{{info.title}}</div>
        </div>
      </div>
		<div class="">
      <div class="content por">
        <div class="list-content Recommended">
          <div class="rem-title mt30 fs40 cr1b1786 fw7" style="width: 650px;margin: 0 auto;">{{$t('Recommended')}}</div>
          <div class="">
            <div class="home-block5" v-for="(item,index) in info.relation_list" @click="getToNav(item)">
              <div class="img-box">
                <img :src="item.cover_image" loading="lazy">
                <span class="status-badge" :class="'status-' + item.status">
                {{ statusText(item.status) }}
              </span>
              </div>
              <div class="home-block5-c disflex">
                <div class="block2-font">
                  <div class="fw7">{{item.title}}</div>
                </div>
                <div class="learn button">{{$t('Watch')}}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>
      <Dialog ref="levelDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " style="color: #2a2d5a;font-size: 50px"> {{$t('Advanced_tips')}}</h2>
          </div>
          <div class="sure_btn" @click="closeBuyPopup">
            <button class=" btn6 font-family mt20" style="line-height: 103px;color: #fff;font-size: 30px;" >{{$t('OK')}}</button>
          </div>
        </div>
      </Dialog>
	</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
import md5 from '../../static/js/md5.min.js'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        info:{},
        id:'',
        startTime: 0,
        totalWatchTime: 0,
        reportingInterval: null,
        videoElement: this.$refs.videoPlayer
      }
    },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    // Clean up event listeners
    clearInterval(this.reportingInterval);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
    watch: {
      '$route'(to, from) {
        if (to.query.id !== from.query.id) {
          this.id = to.query.id;
          this.getList();
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      const videoPlayer = this.$refs.videoPlayer;
      if (videoPlayer) {
        videoPlayer.pause();
        videoPlayer.currentTime = 0;
      }
      if (this.$parent) {
        this.$parent.bgmEnabled = true;        // 允许播放
      }
      next();  // 继续导航
    },
	created(){
    // 暂停背景音乐
    if (this.$parent && this.$parent.stopBackgroundMusic) {
      this.$parent.stopBackgroundMusic(true);
      this.$parent.bgmEnabled = false;
    }
    this.id = this.$route.query.id
    this.videoElement = this.$refs.videoPlayer;
    this.getList()
	},
    methods: {
      back(){
      	this.$router.push({path:'/Advanced'});
      },
      getToNav(item){
        if (this.$route.query.id == item.id) {
          return;
        }
        if(this.$refs.videoPlayer) {
          this.$refs.videoPlayer.play()
          this.$refs.videoPlayer.currentTime = 0
          this.$refs.videoPlayer.src = '';
        }
        this.$router.replace({path:'/AdvancedDetail',query: {id:item.id}});
        this.id = item.id;
        this.getList();
      },
      getList(){
        let that = this
        let data = {
          "detail_id":this.id
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/spoken/detail',data,r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            if (r.data.user_level < 3){
              that.$refs.levelDialog.showMaskFun();
            }else {
              that.info = r.data
            }
          })
        })
      },
      //播放时间
      reportWatchTime(force = false, finished = false) {
        const now = Date.now();
        let currentWatch = (now - this.startTime) / 1000;
        this.totalWatchTime += currentWatch;
        this.startTime = now;
        // Don't report if watch time is less than 5 seconds (unless forced)
        if (!force && currentWatch < 5) return;
        let that = this
        let ts = Date.now();
        let seconds = Math.round(this.totalWatchTime);
        let sign = that.generateSign(seconds, ts);
        let data = {
          video_id: this.id,
          seconds: seconds,
          finished: finished,
          video_type: 'spoken',
          ts: ts,
          sign: sign
        }
        that.$api.post('/api/watch/report_time',data,r =>{
          that.$parent.returnCode(r,function(){

          })
        })
      },
      generateSign(score, ts, secret = "jksdfuiAa4so") {
        const str = String(score) + String(ts) + secret
        return md5(str);
      },
      // Check if we should count time (tab visible, playing normally at 1x speed)
      canCountTime() {
        return !document.hidden &&
          !this.videoElement.paused &&
          this.videoElement.playbackRate === 1.0;
      },

      // Start the reporting interval
      startReporting() {
        this.startTime = Date.now();
        if (this.reportingInterval) clearInterval(this.reportingInterval);

        this.reportingInterval = setInterval(() => {
          if (this.canCountTime()) {
            this.reportWatchTime();
          }
        }, 10000); // Report every 10 seconds
      },

      // Event handlers
      onPlay() {
        console.log('开始播放');
        this.videoElement = this.$refs.videoPlayer;
        if (!this.videoElement) return;
        if (this.videoElement.playbackRate !== 1.0) {

          this.videoElement.pause();
          return;
        }
        this.startReporting();
      },

      onPause() {
        console.log('暂停播放');
        if (this.canCountTime()) {
          this.reportWatchTime();
        }
        clearInterval(this.reportingInterval);
      },

      onEnded() {
        console.log('播放结束');
        this.reportWatchTime(true, true); // Force report and mark as finished
        clearInterval(this.reportingInterval);
      },

      onSeeking() {
        console.log('拖动进度条');
        // Reset timer when seeking to prevent cheating
        this.startTime = Date.now();
      },

      onRateChange() {
        console.log('倍速播放');
        this.videoElement = this.$refs.videoPlayer;
        if (this.videoElement.playbackRate !== 1.0) {

          this.videoElement.pause();
        }
      },

      handleVisibilityChange() {
        this.videoElement = this.$refs.videoPlayer;
        if (document.hidden) {
          this.reportWatchTime(true);
          clearInterval(this.reportingInterval);
        } else if (!this.videoElement.paused) {
          this.startReporting();
        }
      },

      handleBeforeUnload() {
        this.reportWatchTime(true);
      },
      closeBuyPopup(){
        this.$refs.levelDialog.closeMask();
        this.$router.push({path:'/',query: {}});
      },
      statusText(status) {
        switch (status) {
          case 1: return this.$t('no_start')
          case 2: return this.$t('in_process')
          case 3: return this.$t('finished')
          default: return ''
        }
      }
	}
}
</script>
<style scoped>
.sure_btn{
  display: block;
  width: 70%;           /* 按钮宽度，手机上也合适 */
  max-width: 600px;     /* 最大宽度 */
  margin: 20px auto 0;  /* 居中并有间距 */
  padding: 12px 0;      /* 内边距控制高度 */
  font-size: 18px;      /* 字体大小适中 */
  line-height: normal;  /* 去掉原来的103px */
  background: url('../../static/images/level_button.png') no-repeat center;
  background-size: contain;  /* 图片自适应容器 */
  text-align: center;
  color: #fff;
  text-shadow: 2px 2px 0 #001d8c;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.img-box {
  position: relative;
  display: inline-block;
}
.img-box img {
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/AdvancedDetail.vue